import * as C from '../constants/authTypes';
import AuthManager from '../services/AuthManager';

const GENERIC_STATE = {
  data: {},
  error: null,
  fetching: false,
  success: false,
};
const GENERIC_USER = {
  reseller: {},
  resellers: [],
  member:[]
}

const initialState = {
  user: {...GENERIC_USER},
  hubUser: { ...GENERIC_STATE },
  otpData: { ...GENERIC_STATE },
  passwordUpdate: { ...GENERIC_STATE },
  User: { ...GENERIC_STATE },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case C.ACTION_CHECK_SESSION:
      return {
        ...state,
        user: action.payload.user,
      };
    case C.ACTION_LOGOUT:
      AuthManager.logout();
      return state;
    case C.UPDATE_PASSWORD_INITIATED:
      return {
        ...state,
        passwordUpdate: {
          success: false,
          fetching: true,
          error: null,
        },
      };
    case C.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordUpdate: {
          success: true,
          fetching: false,
          error: null,
        },
      };
    case C.UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        passwordUpdate: {
          success: false,
          fetching: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
}
